// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"GS-z","smallCardRow":"HS-z","largeCardRow":"IS-z","productSearchRow":"JS-z","curatedRow":"KS-z"};